export default __webpack_public_path__ + "static/media/seller_invoice_discounting.093dfee4.xlsx";